// extracted by mini-css-extract-plugin
export default {"components-layout-demo-fixed-sider":"layout_components-layout-demo-fixed-sider__kOGE3","logo":"layout_logo__z+uop","siteLayout":"layout_siteLayout__pltu8"};